import { isPresent as isPresentValidator } from '@fretadao/f-js-utils';
import { optionalNumberValidator, numberValidator, enumValidator, optionalDateValidator } from '../row_management/validators';

export default class RfidCellValidator{
  constructor(){
    this.allColumnsValidators = this.#buildColumnsValidators();
  }

  validate(header, value){
    let headerValidators = this.#validatorsForHeader(header);
    if(headerValidators.some((validator) => !validator(value))){
      return false
    }
    return true;
  }

  #validatorsForHeader(header){
    return this.allColumnsValidators[this.#headerNormalization(header)] || [];
  }

  #headerNormalization(header){
    return header.toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .replace(/\s+/g,'_')
  }

  #buildColumnsValidators(){
    return {
      id_do_passageiro: [optionalNumberValidator()],
      numero: [isPresentValidator, numberValidator()],
      situacao: [isPresentValidator, enumValidator('inativo', 'ativo', 'inactive', 'active')],
      enviado_em: [optionalDateValidator()]
    }
  }

}
